import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import FmeaStepProgress from '../../../components/FmeaStepProgress';
import FmeaStepHeader from '../../../components/FmeaStepHeader';

const PlaceholderStep: React.FC = () => {
  const { fmeaId, stepNumber } = useParams<{ fmeaId: string; stepNumber: string }>();
  const navigate = useNavigate();
  const { t: translate } = useTranslation('form');
  const totalSteps = 7;
  const stepIndex = Math.max(0, Math.min(parseInt(stepNumber || '1', 10) - 1, totalSteps - 1));
  const steps = [
    { label: translate('step1PlanningPreparation') },
    { label: translate('step2StructureAnalysis') },
    { label: translate('step3FunctionAnalysis') },
    { label: translate('step4FailureAnalysis') },
    { label: translate('step5RiskAnalysis') },
    { label: translate('step6Optimization') },
    { label: translate('step7FmeaReports') },
  ];
  const currentLabel = steps[stepIndex]?.label || '';
  const stepHeaderTitleKey = `step${stepIndex + 1}DescriptionTitle`;
  const descriptionKey = `step${stepIndex + 1}DescriptionText`;
  const headerTitleTranslation = translate(stepHeaderTitleKey);
  const descriptionTranslation = translate(descriptionKey);
  const resolvedHeaderTitle = headerTitleTranslation === stepHeaderTitleKey ? currentLabel : headerTitleTranslation;
  const resolvedDescription = descriptionTranslation === descriptionKey ? '' : descriptionTranslation;

  return (
    <div className="flex flex-column gap-4">
      <FmeaStepProgress currentStep={stepIndex + 1} />
      <FmeaStepHeader
        title={resolvedHeaderTitle}
        description={resolvedDescription}
      />
      <div className="grid">
        <div className="col-12">
          <div className="flex justify-center items-center" style={{ height: '200px' }}>
            <h3 className="text-gray-500 font-normal">Em desenvolvimento.</h3>
          </div>
        </div>
      </div>
      <div className="col-12 flex justify-between mt-4">
        <Button
          type="button"
          label={translate('Back')}
          icon="pi pi-arrow-left"
          className="p-button-reject"
          onClick={() => navigate(`/fmeas/${fmeaId}/steps/${stepIndex}`)}
        />
        <div className="ml-auto">
          <Button
            type="button"
            label={translate('Next')}
            icon="pi pi-arrow-right"
            className="p-button-success gap-2"
            disabled={stepIndex >= steps.length - 1}
            onClick={() => navigate(`/fmeas/${fmeaId}/steps/${stepIndex + 2}`)}
          />
        </div>
      </div>
    </div>
  );
};

export default PlaceholderStep;